<script>
export default {
  computed: {
    goodConditions() {
      if (typeof this.selected_products === 'undefined') return false;

      return this.selected_products.map((item) => {
        const good = item.filter((subItem) => subItem.condition === 0);

        return good.length === 0 ? good.length : good
          .reduce((sum, current) => sum + Number(current.selected_quantity), 0);
      });
    },
    attentionConditions() {
      if (typeof this.selected_products === 'undefined') return false;

      return this.selected_products.map((item) => {
        const attention = item.filter((subItem) => subItem.condition === 2);

        return attention.length;
      });
    },
    badConditions() {
      if (typeof this.selected_products === 'undefined') return false;

      return this.selected_products.map((item) => {
        const bad = item.filter((subItem) => subItem.condition === 1);

        return bad.length;
      });
    },
  },
  props: [
    'selected_products',
  ],
  methods: {
    remove(subItem) {
      subItem.selected = false;
    },
    validate(product) {
      product.valid = (
        product.selected_quantity > 0 && product.selected_quantity <= product.quantity
      );
    },
  },
};
</script>
<template src="./selected_products.pug" lang="pug"></template>
